module.exports = __webpack_public_path__ + "static/hero-08-578dce3e52e9fc39b8b0fcc3abb421c6.jpg";